<template>
  <div class="base-info">
    <div class="base-info-item">
      <el-card shadow="always" style="margin-bottom: .2rem;">
        <div slot="header" class="clearfix">
          <span>客户信息</span>
        </div>
        <el-row>
          <el-col :span="12">
            <el-row type="flex" class="risks">
              <el-col class="risks-span bg" :span="8">
                <el-popover
                  placement="top"
                  trigger="click"
                  content="客户姓名">
                  <span style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; cursor: pointer;" slot="reference">客户姓名</span>
                </el-popover>
              </el-col>
              <el-col class="risks-span" :span="16">
                <el-popover
                  placement="top"
                  trigger="click"
                  :content="baseInfo.customer ? baseInfo.customer.name : ''">
                  <span style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; cursor: pointer;" slot="reference">{{ baseInfo.customer ? baseInfo.customer.name : '' }}</span>
                </el-popover>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row type="flex" class="risks">
              <el-col class="risks-span bg" :span="8">
                <el-popover
                  placement="top"
                  trigger="click"
                  content="客户手机">
                  <span style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; cursor: pointer;" slot="reference">客户手机</span>
                </el-popover>
              </el-col>
              <el-col class="risks-span" :span="16">
                <el-popover
                  placement="top"
                  trigger="click"
                  :content="baseInfo.customer ? baseInfo.customer.phone : ''">
                  <span style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; cursor: pointer;" slot="reference">{{ baseInfo.customer ? baseInfo.customer.phone : '' }}</span>
                </el-popover>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row type="flex" class="risks">
              <el-col class="risks-span bg" :span="8">
                <el-popover
                  placement="top"
                  trigger="click"
                  content="企业微信群/电话联系记录">
                  <span style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; cursor: pointer;" slot="reference">企业微信群/电话联系记录</span>
                </el-popover>
              </el-col>
              <el-col class="risks-span" :span="16">
                <el-button
                  type="warning"
                  size="mini"
                  icon="el-icon-s-comment"
                  circle
                  @click="handleWxChatOpen(baseInfo.wx_work_chat_com)"
                  :disabled="!baseInfo.wx_work_chat_com"
                ></el-button>
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-phone-outline"
                  circle
                  @click="handCallLogsOpen"
                ></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-card>
      <el-card shadow="always" style="margin-bottom: .2rem;">
        <div slot="header" class="clearfix">
          <span>服务人员</span>
        </div>
        <el-row>
          <el-col :span="12">
            <el-row type="flex" class="risks">
              <el-col class="risks-span bg" :span="8">
                <el-popover
                  placement="top"
                  trigger="click"
                  content="业务员">
                  <span style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; cursor: pointer;" slot="reference">业务员</span>
                </el-popover>
              </el-col>
              <el-col class="risks-span" :span="16">
                <el-popover
                  placement="top"
                  trigger="click"
                  :content="baseInfo.dedicated_consultant ? baseInfo.dedicated_consultant.map(item => item.adminuser ? item.adminuser.username : '').join(', ') : ''">
                  <span style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; cursor: pointer;" slot="reference">{{ baseInfo.dedicated_consultant ? baseInfo.dedicated_consultant.map(item => item.adminuser ? item.adminuser.username : '').join(', ') : '' }}</span>
                </el-popover>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row type="flex" class="risks">
              <el-col class="risks-span bg" :span="8">
                <el-popover
                  placement="top"
                  trigger="click"
                  content="财税负责人">
                  <span style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; cursor: pointer;" slot="reference">财税负责人</span>
                </el-popover>
              </el-col>
              <el-col class="risks-span" :span="16">
                <el-popover
                  placement="top"
                  trigger="click"
                  :content="baseInfo.leader ? baseInfo.leader.map(item => item.adminuser ? item.adminuser.username : '').join(', ') : ''">
                  <span style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; cursor: pointer;" slot="reference">{{ baseInfo.leader ? baseInfo.leader.map(item => item.adminuser ? item.adminuser.username : '').join(', ') : '' }}</span>
                </el-popover>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row type="flex" class="risks">
              <el-col class="risks-span bg" :span="8">
                <el-popover
                  placement="top"
                  trigger="click"
                  content="理票会计">
                  <span style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; cursor: pointer;" slot="reference">理票会计</span>
                </el-popover>
              </el-col>
              <el-col class="risks-span" :span="16">
                <el-popover
                  placement="top"
                  trigger="click"
                  :content="baseInfo.acc ? baseInfo.acc.map(item => item.adminuser ? item.adminuser.username : '').join(', ') : ''">
                  <span style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; cursor: pointer;" slot="reference">{{ baseInfo.acc ? baseInfo.acc.map(item => item.adminuser ? item.adminuser.username : '').join(', ') : '' }}</span>
                </el-popover>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row type="flex" class="risks">
              <el-col class="risks-span bg" :span="8">
                <el-popover
                  placement="top"
                  trigger="click"
                  content="客服会计">
                  <span style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; cursor: pointer;" slot="reference">客服会计</span>
                </el-popover>
              </el-col>
              <el-col class="risks-span" :span="16">
                <el-popover
                  placement="top"
                  trigger="click"
                  :content="baseInfo.ass ? baseInfo.ass.map(item => item.adminuser ? item.adminuser.username : '').join(', ') : ''">
                  <span style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; cursor: pointer;" slot="reference">{{ baseInfo.ass ? baseInfo.ass.map(item => item.adminuser ? item.adminuser.username : '').join(', ') : '' }}</span>
                </el-popover>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row type="flex" class="risks">
              <el-col class="risks-span bg" :span="8">
                <el-popover
                  placement="top"
                  trigger="click"
                  content="记账报税会计">
                  <span style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; cursor: pointer;" slot="reference">记账报税会计</span>
                </el-popover>
              </el-col>
              <el-col class="risks-span" :span="16">
                <el-popover
                  placement="top"
                  trigger="click"
                  :content="baseInfo.advisory ? baseInfo.advisory.map(item => item.adminuser ? item.adminuser.username : '').join(', ') : ''">
                  <span style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; cursor: pointer;" slot="reference">{{ baseInfo.advisory ? baseInfo.advisory.map(item => item.adminuser ? item.adminuser.username : '').join(', ') : '' }}</span>
                </el-popover>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row type="flex" class="risks">
              <el-col class="risks-span bg" :span="8">
                <el-popover
                  placement="top"
                  trigger="click"
                  content="开票会计">
                  <span style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; cursor: pointer;" slot="reference">开票会计</span>
                </el-popover>
              </el-col>
              <el-col class="risks-span" :span="16">
                <el-popover
                  placement="top"
                  trigger="click"
                  :content="baseInfo.invoice ? baseInfo.invoice.map(item => item.adminuser ? item.adminuser.username : '').join(', ') : ''">
                  <span style="width: 100%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: inline-block; cursor: pointer;" slot="reference">{{ baseInfo.invoice ? baseInfo.invoice.map(item => item.adminuser ? item.adminuser.username : '').join(', ') : '' }}</span>
                </el-popover>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <company-wx-work-chat-drawer :drawer="wxWorkChatDrawer" :chat-id="chatId" :chat-name="chatName" @handleClose="handleClose" />
    <company-call-logs-drawer :drawer="callLogsDrawer" :call-company="callCompany" :call-phone="callPhone" :call-phone1="callPhone1" :call-phone2="callPhone2" :call-phone3="callPhone3" @handleClose="handleCallClose" />
  </div>
</template>

<script>
import CompanyWxWorkChatDrawer from "./CompanyWxWorkChatDrawer.vue"
import CompanyCallLogsDrawer from "./CompanyCallLogsDrawer.vue";
export default {
  name: 'CompanyOtherInfo',
  components: {
    CompanyWxWorkChatDrawer,
    CompanyCallLogsDrawer
  },
  props: {
    companyName: {
      type: String,
      default: ''
    }
  },
  computed: {
  },
  watch: {
    companyName: {
      immediate: true,
      handler (val) {
        if (val) this.fetchData()
      }
    }
  },
  data () {
    return {
      baseInfo: {},
      wxWorkChatDrawer: false,
      chatId: '',
      chatName: '',
      callLogsDrawer: false,
      callCompany: '',
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: []
    }
  },
  methods: {
    fetchData () {
      this.$axios.get('/api/admin/upload_task_info/company_data?company_name=' + this.companyName + '&key=基础信息', { loadingClose: true })
        .then((res) => {
          const { data } = res
          if (data.code === 0) {
            this.baseInfo = data.data
          }
        })
    },
    handleWxChatOpen (chat) {
      this.chatId = chat.chat_id
      this.chatName = this.companyName
      this.wxWorkChatDrawer = true
    },
    handleClose (val) {
      this.wxWorkChatDrawer = val
    },
    handCallLogsOpen () {
      this.callCompany = this.companyName
      if (this.baseInfo.user) this.callPhone.push(this.baseInfo.user.phone)
      if (this.baseInfo.docking_phone) this.callPhone3.push(this.baseInfo.docking_phone)
      if (this.baseInfo.tyc_orders.length > 0) {
        for (var i = 0; i < this.baseInfo.tyc_orders.length; i++) {
          if (
            this.baseInfo.tyc_orders[i].customer_phone &&
            this.callPhone1.indexOf(this.baseInfo.tyc_orders[i].customer_phone) === -1
          ) {
            this.callPhone1.push(this.baseInfo.tyc_orders[i].customer_phone)
          }
          if (
            this.baseInfo.tyc_orders[i].corporate_phone &&
            this.callPhone2.indexOf(this.baseInfo.tyc_orders[i].corporate_phone) === -1
          ) {
            this.callPhone2.push(this.baseInfo.tyc_orders[i].corporate_phone)
          }
        }
      }
      this.callLogsDrawer = true
    },
    handleCallClose (val) {
      this.callLogsDrawer = val
      this.callCompany = ''
      this.callPhone = []
      this.callPhone1 = []
      this.callPhone2 = []
      this.callPhone3 = []
    },
    getName (row) {
      console.log('dfdfdf')
      return row.dedicated_consultant ? row.dedicated_consultant.map(item => item.adminuser ? item.adminuser.username : '').join(', ') : ''
    }
  }
}
</script>
<style lang="stylus" scoped>
.risks {
  border: 1px solid #ebeef5;
}
.risks-span {
  display: flex;
  line-height: .4rem;
  padding: 10px;
}
.risks-span span {
  width: 100%;
}
.risks-span-info {
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.bg {
  border-right: 1px solid #ebeef5;
  color: #909399;
  background: #fafafa;
}
</style>



// WEBPACK FOOTER //
// src/pages/company_risks/common/CompanyOtherInfo.vue